import { wp } from '@/lib/api'
import type { Frontpage } from '@/models/frontpage'
import { getWithEtag, type EtagResult } from '@/services/etag'

export type FrontpageData = Frontpage

function fetchFrontpageResource(
  etag?: string | null,
  currentData: FrontpageData | null = null,
): Promise<EtagResult<FrontpageData | null>> {
  return getWithEtag<FrontpageData | null>(
    wp,
    'frontpage',
    {},
    etag,
    currentData,
  )
}

export const FrontpageService = {
  async resource(
    etag?: string | null,
    currentData: FrontpageData | null = null,
  ): Promise<EtagResult<FrontpageData | null>> {
    return fetchFrontpageResource(etag, currentData)
  },

  async get(): Promise<FrontpageData> {
    const result = await fetchFrontpageResource()

    if (!result.data) {
      throw new Error('The frontpage endpoint returned no data.')
    }

    return result.data
  },
}
